const scripts: string[] = [];
const css: string[] = [];

/**
 * @deprecated use scriptLoader from '@eika-infrastruktur/render' instead
 */
export default (document: Document): void => {
    const appContainers = document.querySelectorAll('script[data-src]');
    const scriptTags = Array.from(document.querySelectorAll('script[data-path]')) as HTMLScriptElement[];
    const cssTags = Array.from(document.querySelectorAll('link[data-path]')) as HTMLLinkElement[];

    const addScript = (src: string) => {
        const tag = document.createElement('script');
        tag.src = src;
        tag.async = true;
        tag.dataset.path = src;
        document.head.appendChild(tag);
    };
    const addCss = (href: string) => {
        const tag = document.createElement('link');
        tag.href = href;
        tag.rel = 'stylesheet';
        tag.dataset.path = href;
        document.head.appendChild(tag);
    };
    Array.from(appContainers).forEach((container: HTMLScriptElement) => {
        const { cssSrc, src: scriptSrc } = container.dataset;
        const scriptHit = scriptTags.find((t) => t.dataset.path === scriptSrc);
        const cssHit = cssTags.find((t) => t.dataset.path === cssSrc);

        if (cssSrc && css.indexOf(cssSrc) < 0 && !cssHit) {
            css.push(cssSrc);
            addCss(cssSrc);
        }
        if (scriptSrc && scripts.indexOf(scriptSrc) < 0 && !scriptHit) {
            scripts.push(scriptSrc);
            addScript(scriptSrc);
        }
    });
};
